module.exports = __webpack_public_path__ + "img/meme_06.716dc7c0.jpg";